import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MagicLinkView } from 'views/MagicLinkView';

export const searchSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute('/_auth/magic-link')({
  component: MagicLinkView,
  validateSearch: (search) => {
    return searchSchema.parse(search);
  },
});
